<template>
	<div>
		<button class="button-hollow margin-right-10 mobile-hide" @click="today">{{ $t('label.today') }}</button>
		<button class="button-cut left" @click="previous">
			<span class="icon icon-left" aria-hidden="true"></span>
		</button>
		<datepicker format="DD MMMM" :value="value" @input="getDate" :startYear="2015" :endYear="endYear"></datepicker>
		<button class="button-cut right" @click="next">
			<span class="icon icon-right" aria-hidden="true"></span>
		</button>
	</div>
</template>
<script>
  import Datepicker from '@/components/widgets/datepicker/VueDatepickerLocal'
  export default {
    name: 'TimeTableHeader',
    components: {Datepicker},
    props: ['value'],
    data () {
      return {
        selectedDate: this.value,
        endYear: new Date().getFullYear() + 3
      }
    },
    watch: {
      selectedDate () {
        this.$emit('input', this.selectedDate)
      }
    },
    methods: {
      getDate (date) {
        this.saveScrollPosition()
        this.selectedDate = date
      },
      today () {
        this.saveScrollPosition()
        this.selectedDate = this.$moment().toDate()
      },
      previous () {
        this.saveScrollPosition()
        this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'days').toDate()
      },
      next () {
        this.saveScrollPosition()
        this.selectedDate = this.$moment(this.selectedDate).add(1, 'days').toDate()
      },
      saveScrollPosition () {
        this.$store.commit('SET_TABLE_SCROLL_POSITION', {
          top: document.scrollingElement.scrollTop,
          left: document.scrollingElement.scrollLeft
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/timetable/TimeTableHeader.vue